import { useTranslation } from 'react-i18next';

import { BomPartType } from 'bom/enums';
import { Confirmation } from 'core/components';
import { useAgGridTableContext } from 'core/states';
import { IVendorQuotePart } from 'quotes/types';
import { Color } from 'theme/enums';

interface IProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const RemoveConfirmation = ({ isOpen, onConfirm, onCancel }: IProps) => {
  const { t } = useTranslation();

  const { selectedRows } = useAgGridTableContext();

  const getConfirmationMessage = () => {
    const selectedPricingGroupDiscounts = selectedRows?.filter(
      (part: IVendorQuotePart) => BomPartType.DISCOUNT === part.type
    );

    const hasPricingGroupDiscountSelected = selectedPricingGroupDiscounts?.length > 0;

    if (!hasPricingGroupDiscountSelected) {
      return t('messageConfirmRemoveLines', { count: selectedRows?.length });
    }

    if (selectedPricingGroupDiscounts?.length === selectedRows?.length) {
      return t('messageConfirmRemovePricingGroupDiscount', {
        count: selectedPricingGroupDiscounts?.length,
      });
    }

    return t('messageConfirmRemoveLinesWithPricingGroupDiscount', {
      partsCount: selectedRows?.length,
      count: selectedPricingGroupDiscounts?.length,
    });
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Confirmation
      isOpen={true}
      title={t('titleRemoveLines', { count: selectedRows?.length })}
      message={getConfirmationMessage()}
      confirmBtnLabel={t('buttonLabelRemove')}
      confirmBtnColor={Color.DANGER}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
